import getStore from '@ve/services/getStore/getStore';
import _ from 'underscore';
import { Store, GetterTree } from 'vuex';

import RoutesModels from '@/js/common/components/tour-page/Domain/Model/RoutesModelsv2';
import { BaseState } from '@ve/services/getStore/types';
import RailwayRoutesModels from '@/js/common/components/railwayTours/tourPage/model/RailwayRoutesModelsv2';
import RouteModel from '@/js/common/components/tour-page/Domain/Model/RouteModelv2';
import getCurrentRoute from '@/js/common/components/tour-page/services/getCurrentRoute';
import { TourLoadingStates } from './types/IRoutesStoreState';
import TourProductModelv2 from '@/js/common/components/tour-page/Domain/Model/TourProductModelv2';

export default function RoutesStore({
    model,
}: {
    model: Backbone.Model
}): Store<BaseState> {
    return getStore({
        name: 'mapForRoutes',
        backboneMap: [
            {
                fields: [
                    'actualizeState',
                    'selectedRouteIdentityPk',
                ],
                model,
            },
        ],
        storeOptions: {
            state: {
                foundTourProductsv2: [],
                operatorId: null,
                toursLoadingStates: {},
                tourProducts: [],
                hotelOffers: [],
                previousPriceProvider: null,
            },
            mutations: {
                foundTourProductsv2Change(state, tourProducts) {
                    state.foundTourProductsv2 = tourProducts;
                },
                addTourProduct(state, tourProduct: TourProductModelv2 | null) {
                    if(!tourProduct) return;
                    const tourProducts: TourProductModelv2[] = state.tourProducts;
                    const filteredTourProducts = tourProducts.filter((product) => product.id !== tourProduct.id);
                    state.tourProducts = Object.freeze([...filteredTourProducts, tourProduct]);
                },
                setTourProducts(state, tourProducts: TourProductModelv2[]) {
                    state.tourProducts = Object.freeze(tourProducts);
                },
                setHotelOffers(state, hotelOffers: any[]) {
                    state.hotelOffers = hotelOffers;
                },
                setTourLoadingState(state, params: { identity: string, state: TourLoadingStates }) {
                    state.toursLoadingStates[params.identity] = params.state;
                    state.toursLoadingStates = { ...state.toursLoadingStates };
                },
                setOperatorId(state, operatorId) {
                    state.operatorId = operatorId;
                },
                setPreviousPriceProvider(state, previousPriceProvider) {
                    state.previousPriceProvider = previousPriceProvider;
                },
            },
            actions: {},
            getters: {
                hasAirlineTours: (
                    state,
                ): boolean => {
                    const { foundTourProductsv2 } = state;
                    return !!_.find(foundTourProductsv2, (foundTourProduct) => !foundTourProduct.type || foundTourProduct.type === 'TourProduct');
                },
                hasRwTours: (
                    state,
                ): boolean => {
                    const { foundTourProductsv2 } = state;

                    return !!_.find(foundTourProductsv2, (foundTourProduct) => foundTourProduct.type === 'RailwayTourProduct');
                },
                allRoutes: (
                    state,
                ): RoutesModels | RailwayRoutesModels => {
                    const { foundTourProductsv2, actualizeState } = state;
                    if (!(foundTourProductsv2 && foundTourProductsv2.length)) {
                        return new RoutesModels([]);
                    }

                    const allRoutes = _.chain(foundTourProductsv2)
                        .map((tourProduct) => tourProduct.routes)
                        .flatten()
                        .value();

                    if (allRoutes?.length && allRoutes[0].type === 'RailwayTourProduct') {
                        return new RailwayRoutesModels(allRoutes);
                    }
                    const routes =  new RoutesModels(allRoutes);
                    if(actualizeState === 'completed') {
                        routes.initRecomendations()
                    }
                    return routes;
                },
                selectedRoute: ({ selectedRouteIdentityPk }, { allRoutes }): null | RouteModel => {
                    if (selectedRouteIdentityPk) {
                        const allRoutesValue = allRoutes.value() as RouteModel[];
                        return allRoutesValue.find((item) => item.identityPk === selectedRouteIdentityPk) || null;
                    }
                    return null;
                },
                selectedRouteForRequest: (never, { selectedRoute }) => getCurrentRoute(selectedRoute),
                thereOnlyHotelOffers: (state): boolean => {
                    const { foundTourProductsv2, hotelOffers } = state;

                    return foundTourProductsv2.length === 0 && hotelOffers.length > 0;
                },
            },
        },
    });
}

export const nameRoutesStore = 'mapForRoutes';